import { render } from "./NewItem.vue?vue&type=template&id=746b2c0b&scoped=true"
import script from "./NewItem.vue?vue&type=script&lang=js"
export * from "./NewItem.vue?vue&type=script&lang=js"

import "./NewItem.vue?vue&type=style&index=0&id=746b2c0b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-746b2c0b"]])

export default __exports__